module.exports = __webpack_public_path__ + "img/hose(old).4ed72c06.png";